module.exports = __webpack_public_path__ + "img/produktoptionen.5f9456f3.svg";